// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "route-record" + "." + "a8be802c" + ".chunk.css");